import React from 'react';
import { CheckCircleIcon, WrenchIcon, ClipboardCheckIcon, SettingsIcon, HammerIcon, FileTextIcon } from 'lucide-react';
export function ServicesGrid() {
  const services = [{
    icon: CheckCircleIcon,
    title: 'Certificación para Ministerio de Salud',
    description: 'Cumplimiento total de normativas oficiales con garantía de aprobación'
  }, {
    icon: WrenchIcon,
    title: 'Instalaciones de Gas LP',
    description: 'Sistemas completos, seguros y certificados desde el primer día'
  }, {
    icon: ClipboardCheckIcon,
    title: 'Correcciones por requerimiento',
    description: 'Soluciones rápidas y efectivas para aprobar inspecciones'
  }, {
    icon: SettingsIcon,
    title: 'Mantenimiento preventivo',
    description: 'Mantené tu sistema en óptimas condiciones y cumplimiento continuo'
  }, {
    icon: HammerIcon,
    title: 'Construcción del sistema',
    description: 'Diseño e implementación completa con ingeniería profesional'
  }, {
    icon: FileTextIcon,
    title: 'Planos técnicos',
    description: 'Documentación profesional y aprobada por el Ministerio'
  }];
  return <section className="w-full bg-gray-50 py-20 px-4" data-id="element-59">
      <div className="max-w-7xl mx-auto" data-id="element-60">
        <div className="text-center mb-16" data-id="element-61">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4" data-id="element-62">
            Nuestros Servicios
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-63">
            Soluciones completas e integrales para todas tus necesidades de Gas
            LP
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-64">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border-t-4 border-jazugas-gold group" data-id="element-65">
                <div className="w-16 h-16 bg-gradient-to-br from-jazugas-blue to-jazugas-blue/80 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-66">
                  <Icon className="w-8 h-8 text-white" aria-hidden="true" data-id="element-67" />
                </div>
                <h3 className="text-xl font-bold text-black mb-3 leading-tight" data-id="element-68">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-69">
                  {service.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}